import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "password", "passwordConfirmation" ]

  connect() {
    console.log("Hello, Active Admin JSON Controller here!", this.element);
    console.log(this.textareaTarget);
  }

  generatePassword(event) {
    event.preventDefault();

    var len = 32;
    var charset = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*';
    var arr = new Uint8Array(len);

    crypto.getRandomValues(arr);

    var s = '';
    for (var i = 0; i < len; i++) s += charset[arr[i] % charset.length];

    this.passwordTarget.value = s;
    this.passwordConfirmationTarget.value = s;
  }

}
